export default function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;
  const version = process.env.REACT_APP_DEPLOY_VERSION || "1.0.0";
  let hasPromptedForUpdate = false;

  const promptForUpdate = (waitingWorker) => {
    if (!waitingWorker || hasPromptedForUpdate) return;
    hasPromptedForUpdate = true;

    if (window.confirm("A new version is available. Update now?")) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    }
  };

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`/service-worker.js?v=${encodeURIComponent(version)}`)
      .then((registration) => {
        registration.update();
        promptForUpdate(registration.waiting);

        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;

          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                promptForUpdate(newWorker);
              }
            });
          }
        });

        navigator.serviceWorker.addEventListener("controllerchange", () => {
          window.location.reload();
        });
      })
      .catch(() => {
        // Keep registration failure silent for end users.
      });
  });
}
